// @flow

import React, { type Node } from 'react';
import { TipsBox } from '@tectonics/look-and-feel/shopify/commons/organisms/tips-box';
import calendarTipSrc from './calendar.svg';
import documentTipsSrc from './document.svg';

export function ArgentineCashTipsBox(): Node {
  return (
    <TipsBox title="¡Importante saber!" tipsModel={[
      {
        imgSrc: calendarTipSrc,
        altText: 'calendar icon',
        tipText: 'La confirmación de pago puede demorar hasta 3 días hábiles para verse reflejado en el sítio de tu compra.',
      },
      {
        imgSrc: documentTipsSrc,
        altText: 'do not pay duplicate icon',
        tipText: 'Este voucher es válido sólo para este pedido. Se realizas un pago duplicados, estos serán cancelados.',
      },
    ]}
    />
  );
}
